import { useEffect, useCallback } from 'react';
import { getTargetElement } from '../utils/dom'; // 鼠标点击事件，click 不会监听右键

var defaultEvent = 'click';
export default function useClickAway(onClickAway, target, eventName) {
  if (eventName === void 0) {
    eventName = defaultEvent;
  }

  var handler = useCallback(function (event) {
    var targets = Array.isArray(target) ? target : [target];

    if (targets.some(function (targetItem) {
      var targetElement = getTargetElement(targetItem);
      return !targetElement || (targetElement === null || targetElement === void 0 ? void 0 : targetElement.contains(event.target));
    })) {
      return;
    }

    onClickAway(event);
  }, [onClickAway, typeof target === 'function' ? undefined : target]);
  useEffect(function () {
    document.addEventListener(eventName, handler);
    return function () {
      document.removeEventListener(eventName, handler);
    };
  }, [eventName, handler]);
}